import {
  ADD_BOX_TYPE_FAILURE,
  ADD_BOX_TYPE_REQUEST,
  ADD_BOX_TYPE_SUCCESS,
  ADD_PRODUCT_VOLUME_FAILURE,
  ADD_PRODUCT_VOLUME_REQUEST,
  ADD_PRODUCT_VOLUME_SUCCESS,
  ADD_SESSION__FAILURE,
  ADD_SESSION__REQUEST,
  ADD_SESSION__SUCCESS,
  ASSIGN_BOX_FAILURE,
  ASSIGN_BOX_REQUEST,
  ASSIGN_BOX_SUCCESS,
  BOX_CREATE_BULK_FAILURE,
  BOX_CREATE_BULK_REQUEST,
  BOX_CREATE_BULK_SUCCESS,
  BOX_MOVE_FAILURE,
  BOX_MOVE_REQUEST,
  BOX_MOVE_SUCCESS,
  BOX_PDF_BULK_FAILURE,
  BOX_PDF_BULK_REQUEST,
  BOX_PDF_BULK_SUCCESS,
  CANCEL_SESSION_FAILURE,
  CANCEL_SESSION_REQUEST,
  CANCEL_SESSION_SUCCESS,
  CLEAR_ERRORS,
  CREATE_PLAN_FAILURE,
  CREATE_PLAN_REQUEST,
  CREATE_PLAN_SUCCESS,
  CREATE_SESSION_DYN_FAILURE,
  CREATE_SESSION_DYN_REQUEST,
  CREATE_SESSION_DYN_SUCCESS,
  DELETE_DOCK_MAP_FAILURE,
  DELETE_DOCK_MAP_REQUEST,
  DELETE_DOCK_MAP_SUCCESS,
  FORCE_CLOSE_FAILURE,
  FORCE_CLOSE_REQUEST,
  FORCE_CLOSE_SUCCESS,
  GET_ACTIVE_SESSION_FAILURE,
  GET_ACTIVE_SESSION_REQUEST,
  GET_ACTIVE_SESSION_SUCCESS,
  GET_ASSOCIATED_DOCK_SETTING_FAILURE,
  GET_ASSOCIATED_DOCK_SETTING_REQUEST,
  GET_ASSOCIATED_DOCK_SETTING_SUCCESS,
  GET_BOX_LABEL_FAILURE,
  GET_BOX_LABEL_REQUEST,
  GET_BOX_LABEL_SUCCESS,
  GET_BOX_LIST_FAILURE,
  GET_BOX_LIST_REQUEST,
  GET_BOX_LIST_SUCCESS,
  GET_BOX_VOLUME_SETTING_FAILURE,
  GET_BOX_VOLUME_SETTING_REQUEST,
  GET_BOX_VOLUME_SETTING_SUCCESS,
  GET_DOCK_ASSOCIATED_BOX_FAILURE,
  GET_DOCK_ASSOCIATED_BOX_LABEL_FAILURE,
  GET_DOCK_ASSOCIATED_BOX_LABEL_REQUEST,
  GET_DOCK_ASSOCIATED_BOX_LABEL_SUCCESS,
  GET_DOCK_ASSOCIATED_BOX_REQUEST,
  GET_DOCK_ASSOCIATED_BOX_SUCCESS,
  GET_DOCK_BY_SORTER_ID_FAILURE,
  GET_DOCK_BY_SORTER_ID_REQUEST,
  GET_DOCK_BY_SORTER_ID_SUCCESS,
  GET_DOCK_MAPPING_SUMMARY_FAILURE,
  GET_DOCK_MAPPING_SUMMARY_REQUEST,
  GET_DOCK_MAPPING_SUMMARY_SUCCESS,
  GET_DOCK_SETTING_FAILURE,
  GET_DOCK_SETTING_REQUEST,
  GET_DOCK_SETTING_SUCCESS,
  GET_DROPDOWN_LIST_FAILURE,
  GET_DROPDOWN_LIST_REQUEST,
  GET_DROPDOWN_LIST_SUCCESS,
  GET_INVENTORY_INCOMING_FAILURE,
  GET_INVENTORY_INCOMING_REQUEST,
  GET_INVENTORY_INCOMING_SUCCESS,
  GET_REJECTION_DATA_FAILURE,
  GET_REJECTION_DATA_REQUEST,
  GET_REJECTION_DATA_SUCCESS,
  GET_SESSION_DETAIL_FAILURE,
  GET_SESSION_DETAIL_REQUEST,
  GET_SESSION_DETAIL_SUCCESS,
  GET_SESSION_SUMMARY_FAILURE,
  GET_SESSION_SUMMARY_REQUEST,
  GET_SESSION_SUMMARY_SUCCESS,
  GET_SKU_FAILURE,
  GET_SKU_REQUEST,
  GET_SKU_SUCCESS,
  GET_SKU_WISE_SORTATION_PLAN_FAILURE,
  GET_SKU_WISE_SORTATION_PLAN_REQUEST,
  GET_SKU_WISE_SORTATION_PLAN_SUCCESS,
  GET_SORTER_SESSION_HISTORY_FAILURE,
  GET_SORTER_SESSION_HISTORY_REQUEST,
  GET_SORTER_SESSION_HISTORY_SUCCESS,
  GET_SUB_LOCATION_BY_INVENTORY_FAILURE,
  GET_SUB_LOCATION_BY_INVENTORY_REQUEST,
  GET_SUB_LOCATION_BY_INVENTORY_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  MAP_DOCK_BOX_FAILURE,
  MAP_DOCK_BOX_REQUEST,
  MAP_DOCK_BOX_SUCCESS,
  MAP_DOCK_LIST_FAILURE,
  MAP_DOCK_LIST_REQUEST,
  MAP_DOCK_LIST_SUCCESS,
  PRINT_ASSOCIATED_BOX_LABEL_BULK_FAILURE,
  PRINT_ASSOCIATED_BOX_LABEL_BULK_REQUEST,
  PRINT_ASSOCIATED_BOX_LABEL_BULK_SUCCESS,
  REMOVE_SESSION_FAILURE,
  REMOVE_SESSION_REQUEST,
  REMOVE_SESSION_SUCCESS,
  SAVE_ASSOCIATED_BOX_VOLUME_FAILURE,
  SAVE_ASSOCIATED_BOX_VOLUME_REQUEST,
  SAVE_ASSOCIATED_BOX_VOLUME_SUCCESS,
  SAVE_BOX_VOLUME_SETTING_FAILURE,
  SAVE_BOX_VOLUME_SETTING_REQUEST,
  SAVE_BOX_VOLUME_SETTING_SUCCESS,
  SAVE_DOCK_SETTING_FAILURE,
  SAVE_DOCK_SETTING_REQUEST,
  SAVE_DOCK_SETTING_SUCCESS,
  SAVE_INVENTORY_INCOMING_FAILURE,
  SAVE_INVENTORY_INCOMING_REQUEST,
  SAVE_INVENTORY_INCOMING_SUCCESS,
} from "../Constants/SorterConstants";

// Get Dropdown List Reducers
export const LoginReducers = (
  state = {
    login: {},
  },
  action
) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        loading: true,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        login: action.payload,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Dock By Sorter Id Reducers
export const GetDockBySorterIdReducers = (
  state = {
    DockList: {},
  },
  action
) => {
  switch (action.type) {
    case GET_DOCK_BY_SORTER_ID_REQUEST:
      return {
        loading: true,
      };
    case GET_DOCK_BY_SORTER_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        DockList: action.payload,
      };
    case GET_DOCK_BY_SORTER_ID_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Dropdown List Reducers
export const GetDropdownListReducers = (
  state = {
    dropdown_list: {},
  },
  action
) => {
  switch (action.type) {
    case GET_DROPDOWN_LIST_REQUEST:
      return {
        loading: true,
      };
    case GET_DROPDOWN_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        dropdown_list: action.payload,
      };
    case GET_DROPDOWN_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Dock Mapping Summary Reducers
export const GetDockMappingSummaryReducers = (
  state = {
    dockMapping_Summary: {},
  },
  action
) => {
  switch (action.type) {
    case GET_DOCK_MAPPING_SUMMARY_REQUEST:
      return {
        loading: true,
      };
    case GET_DOCK_MAPPING_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        dockMapping_Summary: action.payload,
      };
    case GET_DOCK_MAPPING_SUMMARY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Map Dock Map Summary Reducers
export const MapDockReducers = (
  state = {
    mapDock: {},
  },
  action
) => {
  switch (action.type) {
    case MAP_DOCK_BOX_REQUEST:
      return {
        loading: true,
      };
    case MAP_DOCK_BOX_SUCCESS:
      return {
        ...state,
        loading: false,
        mapDock: action.payload,
      };
    case MAP_DOCK_BOX_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Dock Setting Reducers
export const getDockSettingReducers = (
  state = {
    dockSetting: {},
  },
  action
) => {
  switch (action.type) {
    case GET_DOCK_SETTING_REQUEST:
      return {
        loading: true,
      };
    case GET_DOCK_SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        dockSetting: action.payload,
      };
    case GET_DOCK_SETTING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Save Dock Setting Reducers
export const saveDockSettingReducers = (
  state = {
    docSettings: {},
  },
  action
) => {
  switch (action.type) {
    case SAVE_DOCK_SETTING_REQUEST:
      return {
        loading: true,
      };
    case SAVE_DOCK_SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        docSettings: action.payload,
      };
    case SAVE_DOCK_SETTING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get/Save Box Volume Setting Reducers
export const BoxVolumeSettingReducers = (
  state = {
    getBoxValueSetting: {},
    saveBoxValueSetting: {},
  },
  action
) => {
  switch (action.type) {
    case GET_BOX_VOLUME_SETTING_REQUEST:
    case SAVE_BOX_VOLUME_SETTING_REQUEST:
      return {
        loading: true,
      };
    case GET_BOX_VOLUME_SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        getBoxValueSetting: action.payload,
      };
    case SAVE_BOX_VOLUME_SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        saveBoxValueSetting: action.payload,
      };
    case GET_BOX_VOLUME_SETTING_FAILURE:
    case SAVE_BOX_VOLUME_SETTING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Map Dock Box List Reducers
export const GetMapDockListReducers = (
  state = {
    mapDockList: {},
  },
  action
) => {
  switch (action.type) {
    case MAP_DOCK_LIST_REQUEST:
      return {
        loading: true,
      };
    case MAP_DOCK_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        mapDockList: action.payload,
      };
    case MAP_DOCK_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get/Save Session Reducers
export const sessionReducers = (
  state = {
    getSessionSummary: {},
    saveSession: {},
  },
  action
) => {
  switch (action.type) {
    case GET_SESSION_SUMMARY_REQUEST:
    case ADD_SESSION__REQUEST:
      return {
        loading: true,
      };
    case GET_SESSION_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        getSessionSummary: action.payload,
      };
    case ADD_SESSION__SUCCESS:
      return {
        ...state,
        loading: false,
        saveSession: action.payload,
      };
    case GET_SESSION_SUMMARY_FAILURE:
    case ADD_SESSION__FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get SKU Reducers
export const getSkuReducers = (
  state = {
    totalSKU: {},
  },
  action
) => {
  switch (action.type) {
    case GET_SKU_REQUEST:
      return {
        loading: true,
      };
    case GET_SKU_SUCCESS:
      return {
        ...state,
        loading: false,
        totalSKU: action.payload,
      };
    case GET_SKU_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Assign Box Reducers
export const AssignBoxReducers = (
  state = {
    AssignBox: {},
  },
  action
) => {
  switch (action.type) {
    case ASSIGN_BOX_REQUEST:
      return {
        loading: true,
      };
    case ASSIGN_BOX_SUCCESS:
      return {
        ...state,
        loading: false,
        AssignBox: action.payload,
      };
    case ASSIGN_BOX_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Cancel Session Reducers
export const CancelSessionReducers = (
  state = {
    cancelSession: {},
  },
  action
) => {
  switch (action.type) {
    case CANCEL_SESSION_REQUEST:
      return {
        loading: true,
      };
    case CANCEL_SESSION_SUCCESS:
      return {
        ...state,
        loading: false,
        cancelSession: action.payload,
      };
    case CANCEL_SESSION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Force Close Reducers
export const ForceCloseReducers = (
  state = {
    ForceClose: {},
  },
  action
) => {
  switch (action.type) {
    case FORCE_CLOSE_REQUEST:
      return {
        loading: true,
      };
    case FORCE_CLOSE_SUCCESS:
      return {
        ...state,
        loading: false,
        ForceClose: action.payload,
      };
    case FORCE_CLOSE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Create Plan Reducers
export const CreatePlanReducers = (
  state = {
    PlanCreate: {},
  },
  action
) => {
  switch (action.type) {
    case CREATE_PLAN_REQUEST:
      return {
        loading: true,
      };
    case CREATE_PLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        PlanCreate: action.payload,
      };
    case CREATE_PLAN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Active Sorter Session Reducers
export const ActiveSorterSessionReducers = (
  state = {
    SorterSession: {},
  },
  action
) => {
  switch (action.type) {
    case GET_SORTER_SESSION_HISTORY_REQUEST:
      return {
        loading: true,
      };
    case GET_SORTER_SESSION_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        SorterSession: action.payload,
      };
    case GET_SORTER_SESSION_HISTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Sku Wise Sortation Plan Reducers
export const GetSkuWiseSortationPlanReducers = (
  state = {
    SKUSortationPlan: {},
  },
  action
) => {
  switch (action.type) {
    case GET_SKU_WISE_SORTATION_PLAN_REQUEST:
      return {
        loading: true,
      };
    case GET_SKU_WISE_SORTATION_PLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        SKUSortationPlan: action.payload,
      };
    case GET_SKU_WISE_SORTATION_PLAN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Rejection Data Reducers
export const GetRejectionDataReducers = (
  state = {
    rejectionValue: {},
  },
  action
) => {
  switch (action.type) {
    case GET_REJECTION_DATA_REQUEST:
      return {
        loading: true,
      };
    case GET_REJECTION_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        rejectionValue: action.payload,
      };
    case GET_REJECTION_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Add Box Type Reducers
export const AddBoxTypeReducers = (
  state = {
    boxType: {},
  },
  action
) => {
  switch (action.type) {
    case ADD_BOX_TYPE_REQUEST:
      return {
        loading: true,
      };
    case ADD_BOX_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        boxType: action.payload,
      };
    case ADD_BOX_TYPE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Active Session Reducers
export const getActiveSessionReducers = (
  state = {
    activeSession: {},
  },
  action
) => {
  switch (action.type) {
    case GET_ACTIVE_SESSION_REQUEST:
      return {
        loading: true,
      };
    case GET_ACTIVE_SESSION_SUCCESS:
      return {
        ...state,
        loading: false,
        activeSession: action.payload,
      };
    case GET_ACTIVE_SESSION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Session Detail Reducers
export const getSessionDetailReducers = (
  state = {
    session_detail: {},
  },
  action
) => {
  switch (action.type) {
    case GET_SESSION_DETAIL_REQUEST:
      return {
        loading: true,
      };
    case GET_SESSION_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        session_detail: action.payload,
      };
    case GET_SESSION_DETAIL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Save Get Inventory Incoming Reducers
export const saveGetInventoryIncomingReducers = (
  state = {
    saveInventoryIncoming: {},
    getInventoryIncoming: {},
  },
  action
) => {
  switch (action.type) {
    case SAVE_INVENTORY_INCOMING_REQUEST:
    case GET_INVENTORY_INCOMING_REQUEST:
      return {
        loading: true,
      };
    case SAVE_INVENTORY_INCOMING_SUCCESS:
      return {
        ...state,
        loading: false,
        saveInventoryIncoming: action.payload,
      };
    case GET_INVENTORY_INCOMING_SUCCESS:
      return {
        ...state,
        loading: false,
        getInventoryIncoming: action.payload,
      };
    case SAVE_INVENTORY_INCOMING_FAILURE:
    case GET_INVENTORY_INCOMING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Sub Location By Invoice Reducers
export const getSubLocationByInvoiceReducers = (
  state = {
    subLocation: {},
  },
  action
) => {
  switch (action.type) {
    case GET_SUB_LOCATION_BY_INVENTORY_REQUEST:
      return {
        loading: true,
      };
    case GET_SUB_LOCATION_BY_INVENTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        subLocation: action.payload,
      };
    case GET_SUB_LOCATION_BY_INVENTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Delete Dock Map Reducers
export const deleteDockMapReducers = (
  state = {
    deleteDock: {},
  },
  action
) => {
  switch (action.type) {
    case DELETE_DOCK_MAP_REQUEST:
      return {
        loading: true,
      };
    case DELETE_DOCK_MAP_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteDock: action.payload,
      };
    case DELETE_DOCK_MAP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Box Move Reducers
export const BoxMoveReducers = (
  state = {
    boxMove: {},
  },
  action
) => {
  switch (action.type) {
    case BOX_MOVE_REQUEST:
      return {
        loading: true,
      };
    case BOX_MOVE_SUCCESS:
      return {
        ...state,
        loading: false,
        boxMove: action.payload,
      };
    case BOX_MOVE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Add Product Volume Reducers
export const AddProductVolumeReducers = (
  state = {
    productVolume: {},
  },
  action
) => {
  switch (action.type) {
    case ADD_PRODUCT_VOLUME_REQUEST:
      return {
        loading: true,
      };
    case ADD_PRODUCT_VOLUME_SUCCESS:
      return {
        ...state,
        loading: false,
        productVolume: action.payload,
      };
    case ADD_PRODUCT_VOLUME_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Box PDF Bulk Reducers
export const BoxPDFBulkLabelReducers = (
  state = {
    pdfBulkLabel: {},
  },
  action
) => {
  switch (action.type) {
    case BOX_PDF_BULK_REQUEST:
      return {
        loading: true,
      };
    case BOX_PDF_BULK_SUCCESS:
      return {
        ...state,
        loading: false,
        pdfBulkLabel: action.payload,
      };
    case BOX_PDF_BULK_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Print Associated Box Label Reducers
export const printAssociatedBoxLabelReducers = (
  state = {
    associated_BoxLabel: {},
  },
  action
) => {
  switch (action.type) {
    case PRINT_ASSOCIATED_BOX_LABEL_BULK_REQUEST:
      return {
        loading: true,
      };
    case PRINT_ASSOCIATED_BOX_LABEL_BULK_SUCCESS:
      return {
        ...state,
        loading: false,
        associated_BoxLabel: action.payload,
      };
    case PRINT_ASSOCIATED_BOX_LABEL_BULK_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Dock Associated Box Reducers
export const getDockAssociatedBoxReducers = (
  state = {
    associateBox: {},
  },
  action
) => {
  switch (action.type) {
    case GET_DOCK_ASSOCIATED_BOX_REQUEST:
      return {
        loading: true,
      };
    case GET_DOCK_ASSOCIATED_BOX_SUCCESS:
      return {
        ...state,
        loading: false,
        associateBox: action.payload,
      };
    case GET_DOCK_ASSOCIATED_BOX_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Dock Associated Box Label Reducers
export const getDockAssociatedBoxLabelReducers = (
  state = {
    associateDockLabel: {},
  },
  action
) => {
  switch (action.type) {
    case GET_DOCK_ASSOCIATED_BOX_LABEL_REQUEST:
      return {
        loading: true,
      };
    case GET_DOCK_ASSOCIATED_BOX_LABEL_SUCCESS:
      return {
        ...state,
        loading: false,
        associateDockLabel: action.payload,
      };
    case GET_DOCK_ASSOCIATED_BOX_LABEL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Save Associated Box Volume Reducers
export const SaveAssociatedBoxSettingReducers = (
  state = {
    AssociatedBox_Setting: {},
  },
  action
) => {
  switch (action.type) {
    case SAVE_ASSOCIATED_BOX_VOLUME_REQUEST:
      return {
        loading: true,
      };
    case SAVE_ASSOCIATED_BOX_VOLUME_SUCCESS:
      return {
        ...state,
        loading: false,
        AssociatedBox_Setting: action.payload,
      };
    case SAVE_ASSOCIATED_BOX_VOLUME_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Associated Dock Setting Reducers
export const getAssociatedDockSettingReducers = (
  state = {
    getAssociatedSetting: {},
  },
  action
) => {
  switch (action.type) {
    case GET_ASSOCIATED_DOCK_SETTING_REQUEST:
      return {
        loading: true,
      };
    case GET_ASSOCIATED_DOCK_SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        getAssociatedSetting: action.payload,
      };
    case GET_ASSOCIATED_DOCK_SETTING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Create Session Reducers
export const CreateSessionReducers = (
  state = {
    createSession: {},
  },
  action
) => {
  switch (action.type) {
    case CREATE_SESSION_DYN_REQUEST:
      return {
        loading: true,
      };
    case CREATE_SESSION_DYN_SUCCESS:
      return {
        ...state,
        loading: false,
        createSession: action.payload,
      };
    case CREATE_SESSION_DYN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Remove Session Reducers
export const RemoveSessionReducers = (
  state = {
    removeSession: {},
  },
  action
) => {
  switch (action.type) {
    case REMOVE_SESSION_REQUEST:
      return {
        loading: true,
      };
    case REMOVE_SESSION_SUCCESS:
      return {
        ...state,
        loading: false,
        removeSession: action.payload,
      };
    case REMOVE_SESSION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Box Create Bulk Reducers
export const BoxCreateBulkReducers = (
  state = {
    BoxCreateBulk: {},
  },
  action
) => {
  switch (action.type) {
    case BOX_CREATE_BULK_REQUEST:
      return {
        loading: true,
      };
    case BOX_CREATE_BULK_SUCCESS:
      return {
        ...state,
        loading: false,
        BoxCreateBulk: action.payload,
      };
    case BOX_CREATE_BULK_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Box List Reducers
export const getBoxListReducers = (
  state = {
    BoxList: {},
  },
  action
) => {
  switch (action.type) {
    case GET_BOX_LIST_REQUEST:
      return {
        loading: true,
      };
    case GET_BOX_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        BoxList: action.payload,
      };
    case GET_BOX_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Get Box Label Reducers
export const getBoxLableReducers = (
  state = {
    BoxLabel: {},
  },
  action
) => {
  switch (action.type) {
    case GET_BOX_LABEL_REQUEST:
      return {
        loading: true,
      };
    case GET_BOX_LABEL_SUCCESS:
      return {
        ...state,
        loading: false,
        BoxLabel: action.payload,
      };
    case GET_BOX_LABEL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// *********************************** Active Session Api ***********************************
